import { render, staticRenderFns } from "./HookText.vue?vue&type=template&id=2aa35af6&"
import script from "./HookText.vue?vue&type=script&lang=js&"
export * from "./HookText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports